import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getYears } from '../../util/ContractAdminUtils';

const CASummaryEntFirstSectInfo = props => {
  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <div>
        <div className="ent-section-header">
          <div className="ent-section-header-col1">Study List</div>
          <div className="ent-section-header-col2">Years</div>
        </div>
        <div className="ent-info-first-sec-colums">
          <div className="ent-section-header-col1">
            {props.studies.map((study, i) => {
              return (
                <div>
                  <div className="summary-ent-info-header">
                    {study.studyName}{' '}
                    {study.marketCount ? `[${study.marketCount}]` : ''}
                  </div>
                  {study.studyAccess.map((item, i) => {
                    return (
                      <div className="access-study-list ">
                        {item.studyAccessName} &nbsp;
                      </div>
                    );
                  })}
                  <div>&nbsp;</div>
                </div>
              );
            })}
            <div className="row">&nbsp;</div>
          </div>
          <div className="ent-section-header-col2">
            {props.studies.map((study, i) => {
              return (
                <div>
                  <div className="summary-ent-info-header">&nbsp;</div>
                  {study.studyAccess.map((item, i) => {
                    return (
                      <div
                        className="ent-info-first-sec-years"
                        title={item.years}
                      >
                        {item.years} &nbsp;
                      </div>
                    );
                  })}
                  <div>&nbsp;</div>
                </div>
              );
            })}
            <div>&nbsp;</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

CASummaryEntFirstSectInfo.propTypes = {
  studies: PropTypes.instanceOf(Object),
};

export default CASummaryEntFirstSectInfo;
